var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cTable',{ref:"table",attrs:{"fields":_vm.fields,"methods":_vm.methods,"config":_vm.config,"footer":_vm.footer}})}
var staticRenderFns = []

export { render, staticRenderFns }